(function () {
  // Bail early if the page is not using Masonry or if jQuery is unavailable.
  const container = document.querySelector('[data-masonry-container]');
  const $ = window.jQuery;
  if (!container || !$) return;

  const init = () => {
    const style = container.dataset.featuredStyle || 'masonry';
    if (style !== 'masonry') return;

    const hasMasonry = typeof $.fn.masonry === 'function';
    if (!hasMasonry) return;

    const $grid = $(container);
    $grid.addClass('is-masonry');

    // Normalize layout: wait for images when possible, then trigger masonry.
    const layout = () =>
      $grid.masonry({
        itemSelector: '.featured__card',
        columnWidth: '.featured__sizer',
        percentPosition: true,
        gutter: 18,
      });

    if (typeof $.fn.imagesLoaded === 'function') {
      $grid.imagesLoaded(layout);
    } else {
      layout();
    }

    window.addEventListener('resize', layout);
  };

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
